import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import addParent from "../addParent/index.vue" //添加家长
import addBaby from "../addBaby/index.vue" //添加宝贝
export default {
    mixins: [services],
    components: {
        addParent,
        addBaby
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            lists: [],
            title: '',
            BabyId: ''
        }
    },
    methods: {
        show(options) {
            this.lists = []
            this.dialogVisible = true
            this.title = options.title
            this.BabyId = options.BabyId
            this.GetBabyParentList()
        },
        // 添加家长
        handleAddParent(row) {
            console.log(row)
            this.$refs.refAddParent.show({
                title: '添加家长',
                BabyId: this.BabyId
            })
        },
        // 选择列表
        handleCurrentChange(row) {
            console.log(row)
            if (row == null) {
                return;
            }
            this.$emit('parentInfo', row)
            this.dialogVisible = false
        },



    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/parentList/vm.js